import CloseButton from './CloseButton';
import MuteButton from './MuteButton';
import stage from './Stage';
import Book from './Book';
import ebook from './EbookContent';
import loader from './Loader';
import native from './Native';
import NextPrevPageButton from './NextPrevPageButton';
import TextVisButton from './TextVisButton';
import SoundManager from '../ts/SoundManager';

class GameManager {
  constructor(ebookModel) {
    this.ebookModel = ebookModel;
    // Instantiate containers
    // Controls whether or not to run a draw frame.
    this.rendering = false;
    // Keeps track of whether we are changing page
    this.changePage = false;
    this.assets = {};
    this.frameCount = 0;
    this.populateStaticAssets();
    loader.loadItems();
    this.textShown = true;
    stage.on('ReadStart', this.startRead, this);
    stage.on('PlayStart', this.startAutoPlay, this);
    stage.on('HomePage', this.handleHome, this);
    stage.on('NextPageBtnPress', this.handleNextPageButtonPress, this);
    stage.on('PreviousPageBtnPress', this.handlePreviousPageButton, this);
  }

  startAutoPlay() {
    this.assets.book.autoPlay(true);
    this.assets.textVisButton.visible = false;
    this.assets.closeButton.visible = true;
    this.textShown = false;
    stage.dispatchEvent('HideTextInstant', true);
  }

  stopAutoPlay() {
    this.assets.book.autoPlay(false);
    this.assets.textVisButton.visible = false;
    this.assets.closeButton.visible = false;
  }

  startRead() {
    this.assets.book.read(true);
    this.assets.textVisButton.visible = true;
    this.assets.closeButton.visible = true;
    stage.dispatchEvent('ShowTextInstant', true);
    this.assets.nextPageButton.visible = true;
  }

  stopRead() {
    this.assets.book.read(false);
    this.assets.textVisButton.visible = false;
    this.assets.closeButton.visible = false;
    this.assets.nextPageButton.visible = false;
    this.assets.previousPageButton.visible = false
  }

  populateStaticAssets() {
    this.assets.book = new Book(this.ebookModel);
    stage.addChild(this.assets.book);
    this.assets.closeButton = new CloseButton();
    this.assets.closeButton.on('pressup', this.handleExitClick.bind(this));
    this.assets.closeButton.visible = false;

    stage.addChildAt(this.assets.closeButton, 1);
    this.assets.muteButton = new MuteButton();
    this.assets.muteButton.on('pressup', this.handleMuteClick.bind(this));
    stage.addChildAt(this.assets.muteButton, 1);

    this.assets.textVisButton = new TextVisButton();
    this.assets.textVisButton.on('pressup', this.handleTextVisClick.bind(this));
    stage.addChildAt(this.assets.textVisButton, 1);
    this.assets.textVisButton.visible = false;

    this.assets.nextPageButton = new NextPrevPageButton('next', 'NextPageBtnPress');
    stage.addChildAt(this.assets.nextPageButton, 2);
    this.assets.nextPageButton.visible = false;

    this.assets.previousPageButton = new NextPrevPageButton('prev', 'PreviousPageBtnPress');
    stage.addChildAt(this.assets.previousPageButton, 2);
    this.assets.previousPageButton.visible = false;
  }

  handleNextPageButtonPress() {
    const pageIndex = this.assets.book.currentPage.index;
    
    const onFirstPage = pageIndex === 1;
    if (onFirstPage) {
      this.assets.previousPageButton.visible = true;
    }

    const onSecondToLastPage =
      pageIndex === Object.keys(this.assets.book.pages).length - 2;
    if (onSecondToLastPage) {
      this.assets.nextPageButton.visible = false;
    }

    stage.dispatchEvent('nextPage', true);
  }

  handlePreviousPageButton() {
    const pageIndex = this.assets.book.currentPage.index;

    const onSecondPage = pageIndex === 2;
    if (onSecondPage) {
      this.assets.previousPageButton.visible = false;
    }

    const onLastPage =
      pageIndex === Object.keys(this.assets.book.pages).length - 1;
    if (onLastPage) {
      this.assets.nextPageButton.visible = true;
    }

    stage.dispatchEvent('previousPage', true);
  }

  handleHome() {
    this.assets.textVisButton.visible = false;
  }

  handleTextVisClick(event) {
    event.stopPropagation();
    this.assets.textVisButton.pressed();
    this.textShown = this.assets.textVisButton.isActive;

    if (this.textShown) {
      stage.dispatchEvent('ShowText', true);
      stage.dispatchEvent('ShowTextButtons', true);
    } else {
      stage.dispatchEvent('HideText', true);
      stage.dispatchEvent('HideTextButtons', true);
    }
  }

  handleMuteClick(event) {
    event.stopPropagation();
    this.assets.muteButton.pressed();
    SoundManager.audibility = this.assets.muteButton.isActive
      ? SoundManager.Audibility.Unmuted
      : SoundManager.Audibility.Muted;
  }

  handleExitClick(event) {
    event.stopPropagation();
    if (this.assets.book.currentPage.index !== 0) {
      this.goToMenu();
    } else {
      native.exitGame();
    }
  }

  goToMenu() {
    this.assets.book.home();
    this.stopAutoPlay();
    this.stopRead();
  }

  rendered() {
    this.assets.forEach(asset => {
      if (asset.render) {
        asset.rendered();
      }
    });
  }

  needRender() {
    let ret = false;
    this.assets.forEach(asset => {
      if (asset.render) {
        ret = ret || asset.needRender();
      }
    });
    return ret;
  }

  run() {
    if (this.needRender()) {
      createjs.Ticker.paused = false;
    } else {
      createjs.Ticker.paused = true;
    }
  }
}

const gameManager = new GameManager(ebook);

export { gameManager as default };
